<!-- @format -->

<template>
  <div class="content h-screen">
    <div class="flex py-4 px-4 bg-white items-center subscription-register-header">
      <img :src="require('@/assets/images/logo/shachihata-logo.svg')" class="h-16"  alt="Shachihata"/>
    </div>

    <div id="subscription-register" class="h-screen flex bg-img vx-row no-gutter items-center justify-center">
      <vx-card v-if="isValid" title="シヤチハタからの下記のお知らせを受け取りますか？" class="w-full lg:w-1/2 xl:w-1/3 px-6 py-6 text-center">
        <vs-checkbox class="mb-4 mx-6" v-for="(subscription, index) in subscriptions" v-model="subscription.isCheck"
                     :key="index">{{ subscription.name }}
        </vs-checkbox>
        <vs-button class="mt-10" color="#1665b2" @click="onConfirmSubscription">登録</vs-button>
      </vx-card>
      <vx-card v-else-if="!this.$route.query.key" title="サブスクリプションの有効期限が切れています" class="w-full lg:w-1/2 xl:w-1/3 px-6 py-6 text-center">
        <vs-button class="mt-10" color="#1665b2" @click="$router.push('/subscription-register')">戻る</vs-button>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'SubscriptionConfirm',
  data() {
    return {
      isValid: false
    }
  },
  computed: {
    ...mapGetters({
      getSubscriptions: 'subscriptions/getSubscriptions'
    }),
    subscriptions() {
      const subscriptions = this.getSubscriptions()
      return subscriptions.map((subscription) => {
        return Object.assign(subscription, {isCheck: Boolean(subscription.customer_id)})
      })
    }
  },
  methods: {
    ...mapActions({
      fetchSubscriptions: 'subscriptions/getSubscriptionForCustomer',
      confirmSubscription: 'subscriptions/confirmSubscription'
    }),
    async onConfirmSubscription() {
      const payload = this.subscriptions.filter((subscription) => subscription.isCheck)
      await this.confirmSubscription({subscriptions: payload, token: this.$route.query.key.split(' ').join('+')})
    }
  },
  async created() {
    if (this.$route.query.key && this.$route.query.key !== '') {
      await this.fetchSubscriptions({token: this.$route.query.key.split(' ').join('+')})
          .then(() => {
            this.isValid = true
          })
          .catch(() => {
            this.$router.push('/subscription-confirm')
            this.isValid = false
          })
    }
  },
}
</script>

<style scoped>
.subscription-register-header {
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.14);
}
</style>
